import React from 'react';
import styled from 'styled-components';

export default styled(({ className }) => (
  <svg
    className={className}
    aria-hidden="true"
    focusable="false"
    role="img"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 34 34"
  >
    <path fill="currentColor" d="m16.846 15.33 1.9 6.324a3.235 3.235 0 1 1-3.8 0l1.9-6.325zm0 7.801a1.345 1.345 0 1 0 0 2.69 1.345 1.345 0 0 0 0-2.69zM17 6.46c3.984 0 7.601 1.536 10.323 4.03.847.723 2.024 2.26 2.024 2.26a15.219 15.219 0 0 1 2.953 9.01c0 .866-.072 1.715-.21 2.541h-2.787c.17-.83.26-1.69.26-2.57l-.004-.065-1.849-.456v-.852l1.725-.333A12.649 12.649 0 0 0 27.99 15.6l-1.97.423-.453-.45 1.478-1.426a12.793 12.793 0 0 0-3.464-3.206l-1.207.763-.686-.183.431-1.37a12.644 12.644 0 0 0-4.346-1.12l-.396 1.502h-.562l-.683-1.515a12.67 12.67 0 0 0-4.708 1.174l.479 1.415-.605.296-1.33-.912a12.784 12.784 0 0 0-3.425 3.215l.963.85-.253.54-1.649.064a12.674 12.674 0 0 0-1.408 4.364l1.686.505v.68l-1.81.456-.004.065c0 .88.089 1.74.259 2.57H1.91a15.376 15.376 0 0 1-.21-2.541c0-8.45 6.85-15.3 15.3-15.3z" />
  </svg>
))``;
